import React, {PropTypes} from 'react';
import {Link} from 'react-router';
import {I18n} from 'react-redux-i18n';

import * as permissions from '../../common/userPermissions';

function activeLinkClass(navLocation, link, className) {
  return `${className} ${navLocation === link ? 'active' : ''}`;
}

const NavIconBar = ({
  navLocation,
  onClick,
  userPermissions
}) => {
  const labelAccess = userPermissions.find((permission) => {
    return permission === permissions.ACCESS_LABELS;
  });

  const careSheetAccess = userPermissions.find((permission) => {
    return permission === permissions.ACCESS_CARE_SHEETS;
  });

  return (
    <div className="center">
      <ul className="nav flex-xl-column">
        {labelAccess && <li className={activeLinkClass(navLocation, '/labels', 'nav-labels')}>
          <Link to="/labels" onClick={onClick}>{I18n.t('LABELS')}</Link>
        </li>}
        {careSheetAccess && <li className={activeLinkClass(navLocation, '/caresheets', 'nav-care-sheets')}>
          <Link to="/caresheets" onClick={onClick}>{I18n.t('CARE_SHEETS')}</Link>
        </li>}
      </ul>
    </div>
  );
};

NavIconBar.propTypes = {
  navLocation: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  userPermissions: PropTypes.array.isRequired
};

export default NavIconBar;


/** WEBPACK FOOTER **
 ** ./src/modules/navbar/components/NavIconBar.js
 **/